import React, { FC } from "react";
import Modal from "../../common/form/Modal";
import ButtonTray from "../../common/form/ButtonTray";

interface props {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    contactId?: string,
    partyId?: string,
    isReadOnly?: boolean;
}

const PrivacyModal: FC<props> = ({ show, setShow }) => {

    return (
        <Modal
            title={"Privacy"}
            show={show}
            setShow={setShow}
            className="w-2/3"
            fields={
                <>
                    <div className="modal-body mr-auto max-h-[70vh] overflow-auto">
                        <div className="max-w-4xl mx-auto ">
                            <p className=" font-semibold mb-4">TitleLogix Solutions, LLC Privacy Notice
                            </p>
                            <p className="mb-4">
                                Effective January 1, 2023
                            </p>
                            <p className="mb-4">
                                TitleLogix Solutions, LLC respects and is committed to protecting your privacy. This Privacy
                                Notice explains if personal information is collected and used.
                            </p>
                            <p className=" font-semibold mb-4">
                                Collection of Personal Information
                            </p>
                            <p className="mb-4">
                                TitleLogix does not collect any Non-public Information.

                            </p>
                            <p className="mb-4">
                                TitleLogix may collect the following category of Information that is required to register
                                for permitted use of certain TitleLogix Sites or applications.
                            </p>
                            <ul className="list-none space-y-2">
                                <li className="list-disc list-inside space-y-2">

                                    <span>You have rights under the California Privacy Act.</span>
                                </li>
                            </ul>

                            <p className=" font-semibold mb-4">
                                Collection of Browsing Information
                            </p>
                            <p className="mb-4">
                                TitleLogix automatically collects the following types of Browsing Information when you
                                access a TitleLogix website, online service, or application (each a “TitleLogix Website”)
                                from your Internet browser, computer, and/or device:
                            </p>

                            <ul className="list-none space-y-2 pl-5">
                                <li className="list-disc list-inside space-y-2">
                                    <span>Internet Protocol (IP) address and operating system</span>
                                </li>
                                <li className="list-disc list-inside space-y-2">
                                    <span>Browser version, language, and type;</span>
                                </li>
                                <li className="list-disc list-inside space-y-2">
                                    <span>Domain name system requests; and</span>
                                </li>
                                <li className="list-disc list-inside space-y-2">
                                    <span>Browsing history on the TitleLogix Website, such as date and time of your visit to the TitleLogix Website and visits to the pages within the TitleLogix Website.</span>
                                </li>
                            </ul>
                            <p className="mb-4">
                                Like most websites, our servers automatically log each visitor to the TitleLogix Website and
                                may collect the Browsing Information described above. We use Browsing Information for system
                                administration, troubleshooting, fraud investigation, and to improve our websites. Browsing
                                Information generally does not reveal anything personal about you, though if you have
                                created a user account for a TitleLogix Website and are logged into that account, the
                                TitleLogix Website may be able to link certain browsing activity to your user acco
                            </p>

                            <p className=" font-semibold mb-4">
                                Other Online Specifics
                            </p>
                            <p className="mb-4">
                                When you visit a TitleLogix Website, a “cookie” may be sent to your computer. A cookie is a
                                small piece of data that is sent to your Internet browser from a web server and stored on
                                your computer’s hard drive. Information gathered using cookies helps us improve our user
                                experience. For example, a cookie can help the website load properly or can customize the
                                display page based on your browser type and user preferences. You can choose whether or not
                                to accept cookies by changing your Internet browser settings. Be aware that doing so may
                                impair or limit some functionality of the TitleLogix Website.
                            </p>
                            <p className=" underline">
                                Web Beacons
                            </p>
                            <p className="mb-4">
                                We use web beacons to determine when and how many times a page has been viewed. This
                                information is used to improve our websites.
                            </p>
                            <p className=" underline">
                                Do Not Track
                            </p>
                            <p className="mb-4">
                                Currently our TitleLogix Websites do not respond to “Do Not Track” features enables through
                                your browser.
                            </p>

                            <p className=" font-semibold mb-4">
                                Use of Personal Information
                            </p>
                            <p className="mb-4">
                                TitleLogix does not collect or use Personal Information. The only information that
                                TitleLogix collects from you is that which is required for you create a User Name and
                                Password required to access TitleLogix proprietary Websites such as TGX.
                            </p>

                            <p className=" font-semibold mb-4">
                                When Information is Disclosed
                            </p>

                            <p className="mb-4">
                                TitleLogix will not disclose any information related to you or your browsing history, with
                                the exception of the following:
                            </p>


                            <ul className="list-none space-y-2 pl-5">
                                <li className="list-disc list-inside space-y-2">
                                    <span>To enable us to detect or prevent criminal activity, fraud, material misrepresentation, or nondisclosure;</span>
                                </li>
                                <li className="list-disc list-inside space-y-2">
                                    <span>To law enforcement or authorities in connection with an investigation, or in response to a subpoena or court order; or</span>
                                </li>
                                <li className="list-disc list-inside space-y-2">
                                    <span>In the good-faith belief that such disclosure is necessary to comply with legal process or applicable laws, or to protest the rights, property, or safety of TitleLogix, its customers, or the public.</span>
                                </li>
                            </ul>
                            <p className="mb-4">
                                The law does not require your prior authorization and does not allow you to restrict the
                                disclosures described above. Additionally, we may disclose your information to third parties
                                for whom you have given us authorization or consent to make such disclosure. We do not
                                otherwise share your Information or Browsing Information with nonaffiliated third parties,
                                except as required or permitted by law.
                            </p>
                            <p className="mb-4">
                                We reserve the right to transfer your Information, Browsing Information, and other
                                information, in connection with the sale or other disposition of all or part of the
                                TitleLogix business and/or assets, or in the event of bankruptcy, reorganization,
                                insolvency, receivership, or an assignment for the benefit of creditors. By submitting
                                Information and/or Browsing Information to TitleLogix, you expressly agree and consent to
                                the use and/or transfer of the foregoing information in connection with any of the above
                                described proceedings.
                            </p>

                            <p className=" font-semibold mb-4">
                                Your Consent to This Privacy Notice; Notice Changes
                            </p>
                            <p className="mb-4">
                                By submitting Information or Browsing Information to TitleLogix, you consent to the
                                collection and use of the information in accordance with this Privacy Notice. We may change
                                this Privacy Notice at any time. The Privacy Notice’s effective date will show the last date
                                changes were made. If you provide information to us following any change of the Privacy
                                Notice, that signifies your assent to and acceptance of the changes to the Privacy Notice.
                            </p>
                            <p className=" font-semibold mb-4">
                                Accessing and Correcting Information; Contact Us
                            </p>
                            <p className="mb-4">
                                If  you  have  question  contact  TitleLogix  by  phone  at  713-453-8822  or  by  email  at
                                <a
                                    href="mailto:inquire@titlelogixsolutions.com"
                                    className="text-highlight-4 underline"> inquire@titlelogixsolutions.com </a>
                                or  by  mail  to:
                            </p>
                            <p className="mt-4 text-center">
                                TitleLogix Solutions, LLC<br />
                                13750 San Pedro Ave.<br />
                                Suite 730<br />
                                San Antonio, TX 78232<br />
                                Attn: Privacy Officer
                            </p>
                        </div>
                    </div>
                    <div className="border-t border-surface-5">
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Close",
                                        onClick: () => setShow(false),
                                        type: "submit",
                                    },
                                    buttonType: "button"

                                },

                            ]}
                            align={"end"}
                            gap={2}
                        />
                    </div>
                </>
            }
        />
    )
}

export default PrivacyModal;